import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { OEPanelBaseModel } from "./oe-panel-base.model";
import { OENLockedState } from "../enums/oe-locked-state.enum";
import {
  ICTenorValueDateModel,
  ICAutocompleteGenericModel,
} from "../../interface/controls/models/bfx-interface-controls.models";
import { ICNInputControlState } from "../../interface/controls/models/bfx-interface-controls.enums";
import { OERateTransportModel } from "./rate/oe-rate-transport.model";

export class OEPanelSpotModel extends OEPanelBaseModel {
  /***************************************/
  /* FINANCIALS */

  /* Order Type (autocomplete) */
  public orderType: {
    label: string;
    labelKey: string;
    dataset: Array<ICAutocompleteGenericModel<any>>;
    disabled: boolean;
    value: ICAutocompleteGenericModel | null;
    externalState: ICNInputControlState | null;
    lockState: OENLockedState;
  } = {
    label: "Type",
    labelKey: "order_entry.panel.label.order_type",
    dataset: [],
    disabled: false,
    value: null,
    externalState: null,
    lockState: OENLockedState.UNLOCKED,
  };

  /* Requested Price/Rate (spinner)*/
  public requestPrice: {
    label: string;
    labelKey: string;
    value: CubiqTS.BigNumber | null;
    lastRateValue: OERateTransportModel | null;
    externalState: ICNInputControlState | null;
    valueToBeLoaded: boolean;
    lockState: OENLockedState;
  } = {
    label: "Request Rate",
    labelKey: "order_entry.panel.label.request_rate",
    value: null,
    lastRateValue: null,
    externalState: null,
    valueToBeLoaded: null,
    lockState: OENLockedState.UNLOCKED,
  };

  /* Value Date (autocomplete)*/
  public valueDate: {
    label: string;
    labelKey: string;
    value: ICTenorValueDateModel | null;
    isSpot: boolean;
    isBrokenDate: boolean;
    dataset: any;
    disabled: boolean;
    externalState: ICNInputControlState;
    state: ICNInputControlState;
    lockState: OENLockedState;
  } = {
    label: "Value date",
    labelKey: "order_entry.panel.label.value_date",
    value: new ICTenorValueDateModel(CubiqTS.Tenor.SPOT, null),
    isSpot: true,
    isBrokenDate: false,
    dataset: null,
    disabled: true,
    externalState: null,
    state: ICNInputControlState.INACTIVE,
    lockState: OENLockedState.UNLOCKED,
  };

  /* Execution Mode (checkbox) */
  public executionMode: {
    label: string;
    labelKey: string;
    show: boolean;
    showConfig: boolean;
    value: CubiqTS.ExecutionType;
    lockState: OENLockedState;
  } = {
    label: "Auto Execute",
    labelKey: "order_entry.execution",
    show: false,
    showConfig: false,
    value: CubiqTS.ExecutionType.MANUAL,
    lockState: OENLockedState.UNLOCKED,
  };

  /* Trigger (autocomplete) */
  public trigger: {
    label: string;
    value: ICAutocompleteGenericModel;
    dataset: Array<ICAutocompleteGenericModel>;
    spotTrigger: ICAutocompleteGenericModel;
    outrightTrigger: ICAutocompleteGenericModel;
    disabled: boolean;
    externalState: ICNInputControlState | null;
    state: ICNInputControlState;
    lockState: OENLockedState;
    locked: boolean;
  } = {
    label: "Trigger",
    value: null,
    dataset: [],
    spotTrigger: new ICAutocompleteGenericModel(CubiqTS.RequestTrackingType.SPOT_RATE, "Spot"),
    outrightTrigger: new ICAutocompleteGenericModel(
      CubiqTS.RequestTrackingType.OUTRIGHT_RATE,
      "Outright",
    ),
    disabled: false,
    externalState: null,
    state: ICNInputControlState.INACTIVE,
    lockState: OENLockedState.UNLOCKED,
    locked: false,
  };

  public ccyPairDatasets: {
    sptFwdDataset: Array<any>;
    mktDataset: Array<any>;
  } = {
    sptFwdDataset: [],
    mktDataset: [],
  };

  public trailingPips: {
    label: string;
    labelKey: string;
    value: CubiqTS.BigNumber | null;
    externalState: ICNInputControlState | null;
    valueToBeLoaded: boolean;
    locked: boolean;
    lockState: OENLockedState;
  } = {
    label: "Trailing Pips",
    labelKey: "order_entry.panel.label.trailing_pips",
    value: null,
    externalState: null,
    valueToBeLoaded: null,
    lockState: OENLockedState.UNLOCKED,
    get locked(): boolean {
      return this.lockState === OENLockedState.LOCKED;
    },
  };

  public trailingTrigger: {
    label: string;
    labelKey: string;
    value: CubiqTS.BigNumber | null;
    externalState: ICNInputControlState | null;
    valueToBeLoaded: boolean;
    lockState: OENLockedState;
    locked: boolean;
    checkbox: {
      value: boolean;
    };
  } = {
    label: "Trailing Trigger",
    labelKey: "order_entry.panel.label.trailing_trigger",
    value: null,
    externalState: null,
    valueToBeLoaded: null,
    lockState: OENLockedState.UNLOCKED,
    get locked(): boolean {
      return this.lockState === OENLockedState.LOCKED;
    },
    checkbox: {
      value: false,
    },
  };
}
